import { Prisma as AdminPrisma } from '@duke-hq/svc-api-db';
import {
  CourseSegment,
  WorkSchedule,
  isCourseSegment,
  isWorkSchedule,
} from '@duke-hq/shared-constants/enrolments';
import { djs } from '@duke-hq/djs';
import {
  CourseReferralModalMode,
  courseReferralModalState,
} from '../tenantState/CourseReferralState';

export const onClickAddSemester = (
  enrolment: AdminPrisma.StudentCourseEnrolmentGetPayload<{
    select: {
      contract_category: true;
      course_segment: true;
      enrolment_contract_type: true;
      externalId: true;
      id: true;
      site_location_id: true;
      consultant_id: true;
      start_at_date: true;
      semesterTwoExternalId: true;
      user_id: true;
      work_schedule: true;
      user: {
        select: {
          first_name: true;
          last_name: true;
          email: true;
          studentData: {
            select: {
              universal_student_identifier: true;
            };
          };
        };
      };
    };
  }> & {
    course?: AdminPrisma.CourseGetPayload<{
      select: {
        id: true;
        identifier: true;
        title: true;
        kind: true;
        status: true;
      };
    }> | null;
  },
  e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
) => {
  e.stopPropagation();
  courseReferralModalState.openModal();
  courseReferralModalState.setMode(CourseReferralModalMode.ADD_SECOND_SEMESTER);
  courseReferralModalState.setSelectedCourseAttributes({
    id: enrolment.course?.id ?? '',
    identifier: enrolment.course?.identifier ?? '',
    price_aud: 0,
    specialisation: '',
    title: enrolment.course?.title ?? '',
    kind: enrolment.course?.kind,
    status: enrolment.course?.status,
  });
  courseReferralModalState.setEnrolmentSettingsData({
    contract_category: enrolment.contract_category,
    course_segment: isCourseSegment(enrolment.course_segment)
      ? enrolment.course_segment
      : CourseSegment.FULL_COURSE,
    enrolment_contract_type: enrolment.enrolment_contract_type,
    external_id: enrolment.externalId ?? '',
    selected_site: {
      site_id: enrolment.site_location_id ?? '',
      site_name: '',
      site_state: '',
    },
    selected_consultant: {
      consultant_id: enrolment.consultant_id ?? '',
      consultant_name: '',
    },
    start_at_date: djs(enrolment.start_at_date).format('YYYY-MM-DD'),
    semester_2_start_at_date: null,
    semesterTwoExternalId: enrolment.semesterTwoExternalId ?? '',
    work_schedule: isWorkSchedule(enrolment.work_schedule)
      ? enrolment.work_schedule
      : WorkSchedule.FULL_TIME,
    studentId: enrolment.user_id,
    enrolmentId: String(enrolment.id),
  });
  courseReferralModalState.setStudent({
    id: enrolment.user_id,
    firstName: enrolment.user.first_name,
    lastName: enrolment.user.last_name ?? '',
    email: enrolment.user.email ?? '',
    usi: enrolment.user.studentData?.universal_student_identifier ?? '',
  });
};
